import './App.css';
import Mint from './Component/Mint/Mint';

function App() {
  return (
    <div className="App">
          <Mint/>
     
    </div>
  );
}

export default App;
